import styled from 'styled-components';

// keeps children vertically centered and widens the apart to the edges with spaces between them
const WideFlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export default WideFlexContainer;
